import { getBasePath } from '../../utils/config';
import {
  IgetCatalogReportsBySeasonAPIResponse,
  IUpdateSeasonBodyProps,
  TassignImagesAPIProps,
  TassignImagesAPIResponse,
  TgetCatalogReportsByUploadAPIResponse,
  TgetImagesPatternAPIResponse,
  TgetUnmatchedImagesAPIProps,
  TgetUnmatchedImagesAPIResponse,
  TmatchImagesAPIResponse,
  TsaveImagesPatternAPIProps,
  TuploadDiscardedImagesAPIResponse,
  TUploadImagesItem,
  TuploadProductImagesAPIProps,
  TuploadProductImagesAPIResponse,
} from 'api/endpoints/catalogUploads/catalogUploads.response.interface';

export const getCatalogReportsByUploadAPI = async (
  brandId: string,
  token: string
): Promise<TgetCatalogReportsByUploadAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/upload_control/uploads?brand_id=${brandId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const publishCatalogUploadAPI = async (
  uploadId: string,
  brandId: string,
  publish: boolean,
  token: string
): Promise<any> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      brand_id: brandId,
      upload_id: uploadId,
      publish: publish,
    }),
  };
  const response = await fetch(`${getBasePath()}/upload_control/publish`, params);
  const data = await response.json();
  return { response, data };
};

export const rejectCatalogUploadAPI = async (
  uploadId: string,
  brandId: string,
  token: string
): Promise<any> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      brand_id: brandId,
      upload_id: uploadId,
    }),
  };
  const response = await fetch(`${getBasePath()}/upload_control/reject`, params);
  const data = await response.json();
  return { response, data };
};

export const getCatalogReportsBySeasonAPI = async (
  brandId: string,
  enabled: boolean,
  token: string
): Promise<IgetCatalogReportsBySeasonAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      brand_id: brandId,
      start: null,
      end: null,
      enabled: enabled,
    }),
  };
  const response = await fetch(`${getBasePath()}/active_season/get_season`, params);
  const data = await response.json();
  return { response, data };
};

export const updateSeasonAPI = async (
  body: IUpdateSeasonBodyProps,
  token: string
): Promise<any> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/active_season/update_season`, params);
  const data = await response.json();
  return { response, data };
};

export const getImagesPatternAPI = async (
  brandId: string,
  token: string
): Promise<TgetImagesPatternAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/image_management/get_pattern?brand_id=${brandId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const saveImagesPatternAPI = async ({
  brandId,
  separator,
  pattern,
  token,
}: TsaveImagesPatternAPIProps): Promise<any> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      brand_id: brandId,
      separator,
      pattern,
    }),
  };
  const response = await fetch(`${getBasePath()}/image_management/save_pattern`, params);
  const data = await response.json();
  return { response, data };
};

export const deleteImagesPatternAPI = async (
  patternId: string,
  token: string
): Promise<any> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/image_management/delete_pattern?id=${patternId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const uploadProductImagesAPI = async ({
  body,
  token,
}: TuploadProductImagesAPIProps): Promise<TuploadProductImagesAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/upload/upload_product_images`, params);
  const data = await response.json();
  return { response, data };
};

export const matchImagesAPI = async ({
  brandId,
  token,
}: {
  brandId: string;
  token: string;
}): Promise<TmatchImagesAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      brand_id: brandId,
    }),
  };
  const response = await fetch(`${getBasePath()}/image_management/match`, params);
  const data = await response.json();
  return { response, data };
};

export const uploadDiscardedImagesAPI = async ({
  brandId,
  discarded_items,
  token,
}: {
  brandId: string;
  discarded_items: TUploadImagesItem[];
  token: string;
}): Promise<TuploadDiscardedImagesAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      brand_id: brandId,
      discarded_items,
    }),
  };
  const response = await fetch(`${getBasePath()}/upload/upload_discarded_images`, params);
  const data = await response.json();
  return { response, data };
};

export const getUnmatchedImagesAPI = async ({
  brandId,
  search,
  index,
  limit,
  token,
}: TgetUnmatchedImagesAPIProps): Promise<TgetUnmatchedImagesAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ brand_id: brandId, search, index, limit }),
  };
  const response = await fetch(
    `${getBasePath()}/image_management/get_unmatched_images`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const assignImagesAPI = async ({
  body,
  token,
}: TassignImagesAPIProps): Promise<TassignImagesAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/product_management/reasign_images`,
    params
  );
  const data = await response.json();
  return { response, data };
};
